import { useCallback } from 'react';
import { useRouter } from 'next/router';

/**
 * returns a click handler function that can be used for links in cms content
 */
export function useClientSideNavigation() {
    const router = useRouter();

    return useCallback(
        (e: React.MouseEvent<HTMLDivElement | HTMLAnchorElement>) => {
            let target = e.target as HTMLElement | null;
            // handle clicks on child elements of the anchor
            while (target && !(target instanceof HTMLAnchorElement)) {
                target = target.parentElement;
            }

            if (target && 'host' in target && target.host === window.location.host) {
                e.preventDefault();
                void router.push(target.href);
                return false;
            }
            return true;
        },
        [router]
    );
}
